import * as React from 'react';

export interface HeaderProps {
    children?: any;
    type: 'h1' | 'h2' | 'h3' | 'h4';
    marginBottom?: boolean;
    className?: string;
}

export function Header(props: HeaderProps) {
    var className = props.marginBottom !== undefined && props.marginBottom ? 'margin-bottom' : '';

    if (props.className !== undefined) {
        className += ' ' + props.className;
    }

    switch (props.type) {        
        case 'h2':
            return <h2 className={className}>{props.children}</h2>;
        case 'h3':
            return <h3 className={className}>{props.children}</h3>;
        case 'h4':
            return <h4 className={className}>{props.children}</h4>;
        case 'h1':
        default:
            return <h1 className={className}>{props.children}</h1>;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Header.tsx